import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {StatusEnum} from "../../../commons/enums/status-enum";
import {manageUserService} from "../../../commons";
import {IUserDTO} from "../../../api-services/manage-user-service";
import {UserStatusEnum} from "../../../commons/enums/user-status-enum";

export interface IUserEditOption {
    userId: number;
    userData: IUserDTO;
}

export interface IUserStatus {
    userId: number;
    status: UserStatusEnum;
}

interface IUserEdit {
    userEditResponseStatus: StatusEnum;
    userToggleStatus: StatusEnum;
}

const initialState: IUserEdit = {
    userEditResponseStatus: StatusEnum.Idle,
    userToggleStatus: StatusEnum.Idle,
};

export const userEdit = createAsyncThunk(
    "manage/userEdit",
    async (options: IUserEditOption, thunkAPI) => {
        try {
            return  await manageUserService.editUser(
                options.userId,
                options.userData
            );
        } catch (e) {
            return thunkAPI.rejectWithValue(e);
        }
    }
);

export const userStatusChange = createAsyncThunk(
    "manage/userStatus",
    async (options: IUserStatus, thunkAPI) => {
        try {
            return await manageUserService.changeStatus(
                options.userId,
                options.status,
            );
        } catch (e) {
            return thunkAPI.rejectWithValue(e);
        }
    }
);

const manageUserEditSlice = createSlice({
    name: "userEdit",
    initialState: initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(userEdit.pending, (state) => {
                state.userEditResponseStatus = StatusEnum.Loading;
            })
            .addCase(userEdit.fulfilled, (state) => {
                state.userEditResponseStatus = StatusEnum.Succeeded;
            })
            .addCase(userEdit.rejected, (state) => {
                state.userEditResponseStatus = StatusEnum.Failed;
            }).addCase(userStatusChange.pending, (state) => {
            state.userToggleStatus = StatusEnum.Loading;
        }).addCase(userStatusChange.fulfilled, (state) => {
            state.userToggleStatus = StatusEnum.Succeeded;
        }).addCase(userStatusChange.rejected, (state) => {
            state.userToggleStatus = StatusEnum.Failed;
        });
    },
});

export default manageUserEditSlice.reducer;
